import React, { useEffect, useState } from 'react';
import { Alert, Box, Link } from '@amzn/awsui-components-console';
import Linkify from 'react-linkify';
import { IS_IT_DOWN_API } from './constants';

interface ILevels {
  [key: number]: {
    status: string;
    type: 'error' | 'success' | 'warning' | 'info' | undefined;
  };
}

const LEVEL_TYPES: ILevels = {
  0: {
    status: 'OK',
    type: 'success',
  },
  1: {
    status: 'Info',
    type: 'info',
  },
  2: {
    status: 'Warn',
    type: 'warning',
  },
  3: {
    status: 'Down',
    type: 'error',
  },
};

interface IsItDownResponse {
  level: number;
  message: string;
  name: string;
  tickets: string;
}

export default function IsItDown(): React.ReactElement {
  const [isItDownResponse, setIsItDownResponse] =
    useState<IsItDownResponse | null>(null);

  const removeAnchorTagFromString = (input = '') => {
    const startAnchorTag = /(<a\b[^>]*>)/g;
    const endAnchorTag = /(<\/a>)/g;

    let parsedInput = input.replace(startAnchorTag, '');

    parsedInput = parsedInput.replace(endAnchorTag, '');
    return parsedInput;
  };

  useEffect(() => {
    fetch(IS_IT_DOWN_API)
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (!data || data.level == 0) return;
        setIsItDownResponse(data);
      });
    return;
  }, []);

  return (
    <>
      {isItDownResponse && isItDownResponse.level !== 0 && (
        <Box padding={{ bottom: 'm' }}>
          <Alert
            type={LEVEL_TYPES[isItDownResponse.level].type ?? 'info'}
            dismissible={true}>
            <Linkify>
              {removeAnchorTagFromString(isItDownResponse.message)}
            </Linkify>
            .
            <Link href={IS_IT_DOWN_API} target="_blank">
              {' '}
              Is DeviceRename down?
            </Link>
          </Alert>
        </Box>
      )}
    </>
  );
}
